import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseUnlockUserAccessProps {
  userId?: string
  entity: 'client' | 'establishment' | ''
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useUnlockUserAccess = ({ userId, entity, onSuccess, onError }: UseUnlockUserAccessProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['unlockUserAccess', userId],
    mutationFn: async () => {
      return await privateAxios.put(`${entity ? `/${entity}` : ''}/users/${userId}/unlock_user_access`)
    },
    onSuccess,
    onError,
  })
}
